import { Fragment, useMemo } from 'react';
import { __ } from '@/hub-shared/utils/i18n';
import type { LifecycleStepKey } from '../../utils/missionLifecycleSteps';

const LIFECYCLE_STEPS: Array<{ key: LifecycleStepKey; label: () => string }> = [
  { key: 'lancement', label: () => __('Lancement') },
  { key: 'completion', label: () => __('Complétion du formulaire') },
  { key: 'supervision', label: () => __('Supervision') },
  { key: 'cloture', label: () => __('Clôture') },
  { key: 'signature', label: () => __('Signature') },
  { key: 'archivage', label: () => __('Archivage') },
];

type MissionProgressBarProps = {
  currentStepKey: LifecycleStepKey;
  signingAvailable?: boolean;
};

const MissionProgressBar = ({ currentStepKey, signingAvailable = true }: MissionProgressBarProps) => {
  const visibleSteps = useMemo(
    () => LIFECYCLE_STEPS.filter((step) => signingAvailable || step.key !== 'signature'),
    [signingAvailable],
  );
  const currentIndex = visibleSteps.findIndex((s) => s.key === currentStepKey);
  const lastIndex = visibleSteps.length - 1;

  return (
    <div className="mission-progress-bar">
      {visibleSteps.map((step, index) => {
        const dotActive = index <= currentIndex;
        // The connector preceding a dot fills orange once that dot is reached.
        const connectorActive = index <= currentIndex;
        const positionClass =
          index === 0
            ? ' mission-progress-bar__step--first'
            : index === lastIndex
              ? ' mission-progress-bar__step--last'
              : '';

        return (
          <Fragment key={step.key}>
            {index > 0 && (
              <div
                className={`mission-progress-bar__connector${
                  connectorActive ? ' mission-progress-bar__connector--active' : ''
                }`}
              />
            )}
            <div className={`mission-progress-bar__step${positionClass}`}>
              <span
                className={`mission-progress-bar__dot${dotActive ? ' mission-progress-bar__dot--active' : ''}`}
                aria-hidden="true"
              />
              <p className="mission-progress-bar__label">{step.label()}</p>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default MissionProgressBar;
